const locale = {
  PleaseSelect: '请选择{label}',
  PleaseInput: '请输入{label}',
  StartTime: '开始时间',
  EndTime: '结束时间',
  StartDate: '开始日期',
  EndDate: '结束日期',
  SoFar: '至今'
};

export default locale;
